module.exports = __webpack_public_path__ + "static/media/placeholder_9.5c566b22.jpg";